import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { PrintOptionFilterOptionDto } from '@/api-sdk';
import { iconStopwatch } from '@/components/icons';
import { baseStyles } from '@/styles';
import { localized, t } from '@weavedev/lit-i18next';

@customElement('fg-print-option-filter-color-option')
@localized()
export class FgPrintOptionFilterColorOption extends LitElement {
  @property({ type: Number })
  subStepIndex: number = 0;

  @property({ type: Object })
  option?: PrintOptionFilterOptionDto;

  render() {
    if (!this.option) {
      return null;
    }

    const { name, image, queryString, hspAvailable } = this.option;

    return html`
      <button class="option" @click=${() => this.selectOption(queryString)}>
        ${image &&
        html`
          <div class="option-image">
            <img src=${image} alt=${name} width="100" height="20" />
          </div>
        `}

        <strong class="option-label">${name}</strong>

        ${hspAvailable
          ? html`
              <span class="option-hsp">
                ${iconStopwatch} ${t('labels.deliveredQuickly')}
              </span>
            `
          : nothing}
      </button>
    `;
  }

  selectOption(queryString: PrintOptionFilterOptionDto['queryString']) {
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        composed: true,
        detail: {
          option: {
            queryString,
            code: this.option?.code,
            subStepIndex: this.subStepIndex,
          },
        },
      }),
    );
  }

  static styles = [
    baseStyles,
    css`
      .option {
        height: 100%;
        min-height: 80px;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        border: 1px solid var(--fg-gray--300, var(--fg-fallback-gray--300));
        border-radius: var(--fg-borderradius, var(--fg-fallback-borderradius));
      }

      .option:hover {
        color: var(--fg-primary, var(--fg-fallback-primary));
        border-color: var(--fg-primary, var(--fg-fallback-primary));
        box-shadow: var(--fg-boxshadow, var(--fg-fallback-boxshadow));
      }

      .option-label {
        font-size: 1rem;
        line-height: 1.6;
      }

      .option-hsp {
        display: flex;
        align-items: center;
        margin-top: 0.25rem;
        gap: 3px;
      }
    `,
  ];
}
